import Button from 'components/ui-kit/buttons/button';
import RequestWorkModal from 'components/request-work-modal';

import { useApp, useModal } from 'hooks';

import * as S from './styles';

const RequestWork = () => {
  const { portal, isPreviewMode } = useApp();
  const { showModal } = useModal();
  const clickHandler = isPreviewMode ? () => {} : () => showModal(RequestWorkModal);

  if (!portal) {
    return <S.InfoBox />;
  }

  return (
    <S.InfoBox>
      <S.ImageContainer>
        <S.BookIcon />
      </S.ImageContainer>

      <S.Text>
        Quickly book
        <br />
        service online
      </S.Text>

      <Button onClick={clickHandler} color="primary">
        Book Online
      </Button>
    </S.InfoBox>
  );
};

export default RequestWork;
